package co.maytes.standupbot.dashboard.components.motion

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Motion
import co.maytes.standupbot.shared.motion.PresencePhase
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div

private const val DISCLOSURE_CLASS = "sb-disclosure"
private const val DISCLOSURE_INNER_CLASS = "sb-disclosure-inner"
private const val SETTLED_CLASS = "sb-settled"

@Composable
fun Disclosure(
    open: Boolean,
    modifier: Modifier = Modifier,
    animateInitial: Boolean = false,
    content: @Composable () -> Unit,
) {
    Presence(
        visible = open,
        enterMs = Motion.DISCLOSURE_MS,
        exitMs = Motion.DISCLOSURE_MS,
        animateInitial = animateInitial,
    ) { presence ->
        Div(attrs = modifier.presenceClasses(DISCLOSURE_CLASS, presence).toAttrs()) {
            val inner = Modifier.classNames(DISCLOSURE_INNER_CLASS)
            Div(
                attrs = (if (presence.phase == PresencePhase.Present) inner.classNames(SETTLED_CLASS) else inner)
                    .toAttrs(),
            ) {
                content()
            }
        }
    }
}
